module.exports = __webpack_public_path__ + "img/WritingTestDirections.3a43e462.png";